// extracted by mini-css-extract-plugin
export var backdropBlur = "_ji-0";
export var contentCard = "_ji-5";
export var frame = "_ji-2";
export var image = "_ji-4";
export var imagePane = "_ji-3";
export var modal = "_ji-1";